
import { IUserEducationRes } from '../models/usereducation.model';
import getService from './getService';
// import postService from './postService';

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://20.126.75.78/naptin/api/v1/';

const USEREDUCATION ='user/educations'
class UserEducationService {
  
  
  async getUserEducation() {
    const response = await getService.get(`${CONFIG_API_URL}${USEREDUCATION}`)
    const res :IUserEducationRes = response.data
    return res;
  }
  
 
}

export default new UserEducationService();